<template>
    <v-layout
    row
    wrap
    >
        <v-flex xs12>
            <v-card class="daterange--default">
                <v-toolbar
                    dark
                    flat
                    color="primary"
                    style="overflow: hidden"
                >
                    <v-toolbar-title>{{$vuetify.t('$vuetify.datePicker.pick')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-divider vertical></v-divider>
                    <div style="margin-top: 22px">
                    <v-switch :label="this.$vuetify.t('$vuetify.datePicker.alltime')" v-model="picker"/>
                    </div>
                    
                    
                </v-toolbar>
                <v-card-text v-if="!picker">
                    <p>{{$vuetify.t('$vuetify.datePicker.from')}}
                    <v-chip>{{ range[0] }}</v-chip> {{$vuetify.t('$vuetify.datePicker.to')}}
                    <v-chip>{{ range[1] }}</v-chip>
                    <v-divider/>
                    <p></p>
                    <v-daterange
                    :options="dateRangeOptions"
                    :labels="labels"
                    :locale="locale"
                    :first-day-of-week="firstDayOfWeek"
                    @input="onDateRangeChange"
                    />
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>


<script>
import { format, subDays } from 'date-fns'

export default {
  props: {
    callbackEvent: {
      type: Function,
      required: false
    }
  },
  data: function () {
    return {
      picker: true,
      range: [],
      labels: {
        start: this.$vuetify.t('$vuetify.datePicker.startDate'),
        end: this.$vuetify.t('$vuetify.datePicker.endDate'),
        preset: this.$vuetify.t('$vuetify.datePicker.preset')
      },
      dateRangeOptions: {
        startDate: format(subDays(new Date(), 7), 'YYYY-MM-DD'),
        endDate: format(new Date(), 'YYYY-MM-DD'),
        format: this.$vuetify.t('$vuetify.datePicker.dateFormat'),
        presets: [
          {
            label: this.$vuetify.t('$vuetify.datePicker.today'),
            range: [
              format(new Date(), 'YYYY-MM-DD'),
              format(new Date(), 'YYYY-MM-DD')
            ]
          },
          {
            label: this.$vuetify.t('$vuetify.datePicker.lastweek'),
            range: [
              format(subDays(new Date(), 7), 'YYYY-MM-DD'),
              format(subDays(new Date(), 0), 'YYYY-MM-DD')
            ]
          },
          {
            label: this.$vuetify.t('$vuetify.datePicker.last30days'),
            range: [
              format(subDays(new Date(), 30), 'YYYY-MM-DD'),
              format(subDays(new Date(), 0), 'YYYY-MM-DD')
            ]
          },
          {
            label: this.$vuetify.t('$vuetify.datePicker.lastyear'),
            range: [
              format(subDays(new Date(), 365), 'YYYY-MM-DD'),
              format(subDays(new Date(), 0), 'YYYY-MM-DD')
            ]
          }
        ]
      },
      locale: this.$vuetify.t('$vuetify.datePicker.locale'),
      firstDayOfWeek: parseInt(this.$vuetify.t('$vuetify.datePicker.firstdayofweek'))
    }
  },
  mounted () {
  },
  watch: {
    picker (newval) {
      this.callbackEvent(newval)
    }
  },
  methods: {
    onDateRangeChange (range) {
      this.range = range
      this.callbackEvent(range)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Misc/DateRange.vue